import React, { createContext, useContext, useState, useEffect } from "react";

export const DistrictContext = createContext(); // <-- export here

export const DistrictProvider = ({ children }) => {
  const [selectedDistrict, setSelectedDistrict] = useState(() => {
    const mcData = JSON.parse(localStorage.getItem("MCData")) || {};
    return mcData.selectedDistrict || "";
  });

  // Write changes to localStorage
  useEffect(() => {
    const mcData = JSON.parse(localStorage.getItem("MCData")) || {};
    mcData.selectedDistrict = selectedDistrict;
    localStorage.setItem("MCData", JSON.stringify(mcData));
  }, [selectedDistrict]);

  // Listen for external changes to localStorage
  useEffect(() => {
    const handleStorageChange = () => {
      const mcData = JSON.parse(localStorage.getItem("MCData")) || {};
      if (mcData.selectedDistrict !== selectedDistrict) {
        setSelectedDistrict(mcData.selectedDistrict || "");
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, [selectedDistrict]);

  return (
    <DistrictContext.Provider value={{ selectedDistrict, setSelectedDistrict }}>
      {children}
    </DistrictContext.Provider>
  );
};

export const useDistrict = () => useContext(DistrictContext);
